import {REVIEW_FIND_ALL} from "../utils/Constant";

const reviews = function (state = {}, action) {
  switch (action.type) {
    case REVIEW_FIND_ALL:

      return state;
    default :
      return state;
  }
}

export default reviews;
